module.exports = __webpack_public_path__ + "img/games.ac9cebe2.png";